import { KakaoMap, Container } from "components";
import SearchInput from "components/molecules/SearchInput";

const TestPage = () => {
  return (
    <Container>
      <SearchInput />
    </Container>
  );
};

export default TestPage;
